// extracted by mini-css-extract-plugin
export default {"cModalForm":"ModalForm_cModalForm__gaKxG"};